/** Which invoices belong in the user-facing payment history.
 *
 * Every abandoned checkout leaves an invoice behind, first `pending`, later
 * `expired` — noise that reads like unpaid debt. Money that actually moved
 * (or explicitly failed to) stays visible, and unknown statuses are shown
 * rather than silently dropped so a new backend status never hides a charge.
 */
export function isInvoiceVisible(status: string): boolean {
  const s = (status ?? "").trim().toLowerCase();
  return s !== "pending" && s !== "expired";
}
